import { Spinnerbtn } from "./Customloader";
import { useState } from "react";
import "./AddressBook.css";
import EditModel from "./EditModel";
import AddressForm from "./AddressForm";
import { setdata } from "../../../../../../helpers/helpers";
import Confirm from "./Popups/Confirm";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";
import { showSnackBar } from "../../../../../../store/common/snackBarSlice";
import { useDispatch } from "react-redux";
import {
  createAddress,
  editAddress,
  deleteAddress,
} from "../../../../../../services/ShipperServices/AddressBook/address.services";
import AddressSelector from "./AddressSelector";

export default function AddressBook(props) {
  const {
    AddressBook,
    SetAddressBook,
    StepCheck,
    SetStepCheck,
    List,
    SetList,
    addressid,
    setaddressid,
  } = props;

  const dispatch = useDispatch();

  const [disable, setdisable] = useState();
  const [show, setshow] = useState(false);
  const [showDel, setshowDel] = useState(false);

  const handlemodel = () => {
    setshow(!show);
  };

  const handleaddress = (number) => {
    const selected = AddressBook[number - 1];
    if (!selected) return;

    setaddressid(number);

    SetStepCheck((prev) => ({
      ...prev,
      ...(List.type === "Flist"
        ? { Pickup_Address_bit: 0 }
        : { Delivery_Address_bit: 0 }),
      QuoteCheck: false,
    }));

    const setField = (key) => setdata(() => selected[key], false, "");

    SetList({
      ...List,
      address: setField("address"),
      countrycode: setField("countrycode"),
      statecode: setField("statecode"),
      country: setField("country"),
      city: setField("city"),
      state: setField("state"),
      zip: setField("zip"),
      company: setField("company"),
      attention: setField("attention"),
      phone: setField("phone"),
      email: setField("email"),
      notification: JSON.parse(selected.notification || "false"),
      otime: setField("otime"),
      ctime: setField("ctime"),
      instruction: setField("instruction"),
      residential: JSON.parse(selected.residential || "false"),
    });
  };

  const handleaddressadd = async () => {
    setdisable("add");

    const payload = {
      addressid: addressid,
      phone: List["phone"],
      address: List["address"],
      country: List["country"],
      state: List["state"],
      city: List["city"],
      zip: List["zip"],
      company: List["company"],
      attention: List["attention"],
      email: List["email"],
      notification: List["notification"],
      otime: List["otime"],
      ctime: List["ctime"],
      date: List["date"],
      instruction: List["instruction"],
      countrycode: List["countrycode"],
      statecode: List["statecode"],
      residential: List["residential"],
    };

    const response = await createAddress(payload);

    if (!response.error) {
      SetAddressBook(response?.data?.data);
      setdisable("");
      dispatch(
        showSnackBar({
          text: response?.data?.message,
          severity: "success",
        })
      );
    } else {
      setdisable("");
      dispatch(
        showSnackBar({
          text: "Something went wrong",
          severity: "error",
        })
      );
    }
  };

  const handleaddressdel = async () => {
    setdisable("del");

    const response = await deleteAddress(AddressBook[addressid - 1]["id"]);

    if (!response.error) {
      SetAddressBook(response?.data?.data);
      SetList({
        ...List,
        address: "",
        countrycode: "",
        statecode: "",
        country: "",
        city: "",
        state: "",
        zip: "",
        company: "",
        attention: "",
        phone: "",
        email: "",
        notification: false,
        residential: false,
        otime: "",
        ctime: "",
        instruction: "",
      });
      setaddressid(0);
      setdisable("");
      dispatch(
        showSnackBar({
          text: response?.data?.message,
          severity: "success",
        })
      );
    } else {
      setdisable("");
      dispatch(
        showSnackBar({
          text: "Something went wrong",
          severity: "error",
        })
      );
    }
  };

  const handleaddressedit = async () => {
    setdisable("edit");

    const payload = {
      addressid: addressid,
      phone: List["phone"],
      address: List["address"],
      country: List["country"],
      state: List["state"],
      city: List["city"],
      zip: List["zip"],
      company: List["company"],
      attention: List["attention"],
      email: List["email"],
      notification: List["notification"],
      otime: List["otime"],
      ctime: List["ctime"],
      date: List["date"],
      instruction: List["instruction"],
      countrycode: List["countrycode"],
      statecode: List["statecode"],
      residential: List["residential"],
    };

    const response = await editAddress(
      payload,
      AddressBook[addressid - 1]["id"]
    );

    if (!response.error) {
      SetAddressBook(response?.data?.data);
      setdisable("");
      handlemodel();
      dispatch(
        showSnackBar({
          text: response?.data?.message,
          severity: "success",
        })
      );
    } else {
      setdisable("");
      dispatch(
        showSnackBar({
          text: "Something went wrong",
          severity: "error",
        })
      );
    }
  };

  const handlePageChange = (page) => {
    handleaddress(page);
    setaddressid(page);
  };

  return (
    <>
      <Confirm
        open={showDel}
        setOpen={setshowDel}
        handleConfirm={handleaddressdel}
        text={
          "Do you want to Delete this Address ID : " +
          AddressBook[addressid - 1]?.company +
          " ?"
        }
      />

      <AddressSelector
        AddressBook={AddressBook}
        handleaddress={handlePageChange}
      />
      <div className="formdata__pagination_id_controler">
        {StepCheck["fullform"] === true && (
          <div className="formdata__pagination_controler_btn mt-2">
            <Tooltip title="Save to Address Book For Quick Access">
              <button
                type="button"
                onClick={() => handleaddressadd()}
                disabled={disable === "add" ? true : false}
                className="formdata__pagination_controler_btn_btnadd"
              >
                {disable === "add" ? (
                  <div className="p-1">
                    <Spinnerbtn
                      style={{
                        zIndex: 1,
                      }}
                    />
                  </div>
                ) : (
                  "Save to Address Book"
                )}
              </button>
            </Tooltip>
            {AddressBook.length > 0 && addressid > 0 && (
              <>
                <Tooltip title="Edit AddressBook">
                  <a
                    onClick={handlemodel}
                    type="button"
                    className="formdata__pagination_controler_btn_btnedit"
                  >
                    Edit
                  </a>
                </Tooltip>
                <Tooltip title="Delete from AddressBook">
                  <button
                    onClick={() => setshowDel(!show)}
                    type="button"
                    disabled={disable === "del" ? true : false}
                    className="formdata__pagination_controler_btn_btndlt"
                  >
                    {disable === "del" ? (
                      <div className="p-1">
                        <Spinnerbtn
                          style={{
                            zIndex: 1,
                          }}
                        />
                      </div>
                    ) : (
                      "Delete"
                    )}
                  </button>
                </Tooltip>
              </>
            )}
          </div>
        )}
      </div>

      <EditModel
        Show={show}
        Disable={disable}
        HandleClose={handlemodel}
        HandleAddressEdit={handleaddressedit}
        AddressId={addressid}
      >
        <AddressForm
          List={List}
          SetList={SetList}
          StepCheck={StepCheck}
          SetStepCheck={SetStepCheck}
        />
      </EditModel>
    </>
  );
}
